import type { JSX } from 'react';
import { Link } from "react-router-dom";

export default function Footer(): JSX.Element {
  return (
    <footer className="bg-white/30 border-t border-border text-white">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-sm">
            <a className="font-medium" href='https://kitm.lt'>KITM</a>
            <span className="mt-1 text-xs text-white/80 px-1">© {new Date().getFullYear()}</span>
          </p>

          <nav className="flex items-center space-x-4 text-sm">
            <Link
              to="/privacy"
              className="text-white hover:text-white/90 underline-offset-4 hover:underline"
            >
              Privatumo politika
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
